module.exports = __webpack_public_path__ + "static/scale-model-of-capitol-park-museum-in-baton-rouge-louisiana-0375641b053a68c60ce3414680a6fffa.png";